export default __webpack_public_path__ + "static/media/ca87e1c035a830334c03f96c5dfcf131.svg";